var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:`base-status-box base-status-box-${_vm.type}`},[_vm._v("\n\t"+_vm._s(_vm.message)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }